export default __webpack_public_path__ + "static/media/12.a276083b.png";